import { render, staticRenderFns } from "./b-table-pag.vue?vue&type=template&id=34d3e54e&scoped=true&"
import script from "./b-table-pag.vue?vue&type=script&lang=ts&"
export * from "./b-table-pag.vue?vue&type=script&lang=ts&"
import style0 from "./b-table-pag.vue?vue&type=style&index=0&id=34d3e54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3e54e",
  null
  
)

export default component.exports